import {
  Component,
  EnvironmentInjector,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import * as environment from '../../../core/appSettings';
import {
  Banner,
  BannerType,
  CmsApiService,
} from 'src/app/services/cms-api.service';
import { BehaviorSubject, Subscription, switchMap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-floating-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-banner.component.html',
  styleUrl: './floating-banner.component.css',
})
export class FloatingBannerComponent implements OnInit, OnDestroy {
  isVisible = false;
  public bannerData: Banner | null = null;

  cmsApiUrl: string = environment.getAppSettings(this.envInjector)?.['cms_url'];

  private hasDataSubject = new BehaviorSubject<boolean>(false);
  hasData$ = this.hasDataSubject.asObservable();
  private langChangeSub: Subscription | undefined;

  constructor(
    @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector,
    private _translocoService: TranslocoService,
    private cmsApi: CmsApiService
  ) {
    setTimeout(() => {
      this.isVisible = true;
    }, 1000);
  }

  ngOnInit(): void {
    this.langChangeSub = this._translocoService.langChanges$
      .pipe(
        switchMap((lang) => {
          return this.cmsApi.banners(BannerType.Floating);
        })
      )
      .subscribe((banner) => {
        this.bannerData = banner[0];
        this.hasDataSubject.next(!!banner[0]);
      });
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }

  closeBanner() {
    this.isVisible = false;
  }
}
